// extracted by mini-css-extract-plugin
export default {"selected":"_9396f24137","un":"_3e8e848383"};